import type { ActivityViewProps } from '../../core/types/activity.types';
import { DataChartView } from './DataChartView';

export function DataChartActivityView(props: ActivityViewProps<'data_chart'>) {
  return <DataChartView payload={props.payload} />;
}
